// 📄 components/StepReceiptParams.tsx
import React from 'react';
import { AlertCircle } from 'lucide-react';
import { ReceiptFormData } from '../../../../../services/commerce/integrationService';

interface StepReceiptParamsProps {
  allowedMovement101: boolean;
  allowedMovement102: boolean;
  allowedMovement122: boolean;
  onChange: (field: keyof ReceiptFormData, value: any) => void;
}

export function StepReceiptParams({ allowedMovement101, allowedMovement102, allowedMovement122, onChange }: StepReceiptParamsProps) {
  return (
    <div className="space-y-4 animate-fadeIn">
      <div className="bg-blue-500/5 border border-blue-500/10 rounded-xl p-3 mb-2 space-y-1">
        <span className="text-[10px] font-bold text-blue-400 uppercase tracking-widest block">Ruta SPRO / Transacción SAP</span>
        <p className="font-mono text-xs text-gray-300">
          <span className="bg-zinc-800 px-1.5 py-0.5 rounded text-gray-400 font-bold mr-1.5">SPRO</span>
          <span>Integration with Other SAP Components → SAP Ariba Cloud Integration Gateway → Application-Specific Settings → Goods Receipt → Maintain Parameters</span>
        </p>
      </div>

      <div>
        <h3 className="text-lg font-medium text-blue-400">2. Maintain Parameters (Movimientos Permitidos)</h3>
        <p className="text-sm text-gray-400">
          Habilita los tipos de movimiento de mercancía (Movement Type) que deben publicarse hacia SAP Ariba como recepción.
        </p>
      </div>

      <div className="bg-white/5 p-4 rounded-xl border border-white/5 space-y-4">
        <div className="flex items-center justify-between gap-4">
          <div>
            <label className="block text-sm font-medium text-white">Movimiento <code className="bg-black/30 px-1 rounded font-mono text-blue-400">101</code></label>
            <p className="text-xs text-gray-400 mt-0.5">Goods Receipt for Purchase Order</p>
          </div>
          <label className="relative inline-flex items-center cursor-pointer flex-shrink-0">
            <input type="checkbox" checked={allowedMovement101 || false} onChange={(e) => onChange('allowedMovement101', e.target.checked)} className="sr-only peer" />
            <div className="w-9 h-5 bg-zinc-700 rounded-full peer peer-checked:after:translate-x-full peer-checked:bg-blue-500 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all"></div>
          </label>
        </div>

        <div className="border-t border-white/5 pt-3 flex items-center justify-between gap-4">
          <div>
            <label className="block text-sm font-medium text-white">Movimiento <code className="bg-black/30 px-1 rounded font-mono text-blue-400">102</code></label>
            <p className="text-xs text-gray-400 mt-0.5">Reversal of Goods Receipt for Purchase Order</p>
          </div>
          <label className="relative inline-flex items-center cursor-pointer flex-shrink-0">
            <input type="checkbox" checked={allowedMovement102 || false} onChange={(e) => onChange('allowedMovement102', e.target.checked)} className="sr-only peer" />
            <div className="w-9 h-5 bg-zinc-700 rounded-full peer peer-checked:after:translate-x-full peer-checked:bg-blue-500 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all"></div>
          </label>
        </div>

        <div className="border-t border-white/5 pt-3 flex items-center justify-between gap-4">
          <div>
            <label className="block text-sm font-medium text-white">Movimiento <code className="bg-black/30 px-1 rounded font-mono text-blue-400">122</code></label>
            <p className="text-xs text-gray-400 mt-0.5">Return Delivery to Vendor (Unrestricted-use)</p>
          </div>
          <label className="relative inline-flex items-center cursor-pointer flex-shrink-0">
            <input type="checkbox" checked={allowedMovement122 || false} onChange={(e) => onChange('allowedMovement122', e.target.checked)} className="sr-only peer" />
            <div className="w-9 h-5 bg-zinc-700 rounded-full peer peer-checked:after:translate-x-full peer-checked:bg-blue-500 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all"></div>
          </label>
        </div>
      </div>

      <div className="bg-blue-500/10 border border-blue-500/20 rounded-xl p-4 text-blue-400 flex gap-3 text-sm">
        <AlertCircle className="w-5 h-5 flex-shrink-0" />
        <div>
          <p className="font-semibold">Movimientos adicionales</p>
          <p className="text-xs text-blue-400/80 mt-0.5">
            Si el cliente requiere publicar otros movimientos (ej. 103/105 para bloqueo en tránsito), regístralos como una Personalización / Desarrollo Z en la sección inferior.
          </p>
        </div>
      </div>
    </div>
  );
}
